import { render, staticRenderFns } from "./Home6.vue?vue&type=template&id=2bf7c712&"
import script from "./Home6.vue?vue&type=script&lang=js&"
export * from "./Home6.vue?vue&type=script&lang=js&"
import style0 from "./Home6.vue?vue&type=style&index=0&id=2bf7c712&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports